import React from "react";
// import sections
import Hero from "../components/sections/Hero";
import FeaturesTiles from "../components/sections/FeaturesTiles";

const QR = () => {
  return (
    <>
      <Hero className="illustration-section-01" />

      <FeaturesTiles />
    </>
  );
};

export default QR;
